import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ToneGuardPage from "@/pages/ToneGuardPage";
import InsightsPage from "@/pages/InsightsPage";
import { Toaster } from "sonner";
import { initPostHog } from "@/lib/posthogClient";
import { AuthProvider } from "@/lib/authContext";
import AuthGate from "@/components/AuthGate";
import { installScopedStorage } from "@/lib/storageScope";

// Install the scoped-localStorage wrapper synchronously, before any storage
// module can read or write. AuthProvider activates the scope (per user_id)
// after /api/auth/me succeeds.
installScopedStorage();

function App() {
    // One-shot PostHog init on app mount. Safe to call in StrictMode: the
    // helper itself is idempotent and skips the second invocation.
    useEffect(() => {
        initPostHog();
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AuthGate>
                        <Routes>
                            <Route path="/" element={<ToneGuardPage />} />
                            <Route path="/tonemirror" element={<InsightsPage />} />
                            <Route
                                path="/insights"
                                element={<Navigate to="/tonemirror" replace />}
                            />
                        </Routes>
                    </AuthGate>
                </AuthProvider>
            </BrowserRouter>
            <Toaster position="top-center" richColors closeButton />
        </div>
    );
}

export default App;
